import { AnalyticsClient } from './AnalyticsClient';
import { setAnalyticsClient } from './useAnalytics';

export function initializeAnalyticsClient(
  cloudId: string | undefined,
  spaceId: string | undefined,
  userId: string | undefined,
  env: string,
  version: string
): void {
  setAnalyticsClient(new AnalyticsClient(cloudId, userId, spaceId, env, version));
}
